import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Portfolio from "@/pages/Portfolio";
import Projects from "@/pages/Projects";
import Settings from "@/pages/Settings";
import ImportWizard from "@/pages/ImportWizard";
import AuditLog from "@/pages/AuditLog";
import Notifications from "@/pages/Notifications";
import ProjectLayout from "@/pages/project/ProjectLayout";
import Dashboard from "@/pages/project/Dashboard";
import Info from "@/pages/project/Info";
import Budget from "@/pages/project/Budget";
import Transactions from "@/pages/project/Transactions";
import Units from "@/pages/project/Units";
import Financing from "@/pages/project/Financing";
import Coinvest from "@/pages/project/Coinvest";
import Brochure from "@/pages/project/Brochure";
import CashFlow from "@/pages/project/CashFlow";
import Scenarios from "@/pages/project/Scenarios";
import Taxes from "@/pages/project/Taxes";
import Controls from "@/pages/project/Controls";
import Documents from "@/pages/project/Documents";
import Reports from "@/pages/project/Reports";
import { Loading } from "@/components/Kpi";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function Guard({ perm, children }) {
  const { can } = useAuth();
  if (!can(perm)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Portfolio />} />
            <Route path="/operazioni" element={<Projects />} />
            <Route path="/operazioni/:id" element={<ProjectLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="anagrafica" element={<Info />} />
              <Route path="conto-economico" element={<Budget />} />
              <Route path="movimenti" element={<Transactions />} />
              <Route path="unita" element={<Units />} />
              <Route path="finanziamenti" element={<Financing />} />
              <Route path="co-investimento" element={<Coinvest />} />
              <Route path="brochure" element={<Brochure />} />
              <Route path="cash-flow" element={<CashFlow />} />
              <Route path="scenari" element={<Scenarios />} />
              <Route path="imposte" element={<Taxes />} />
              <Route path="controlli" element={<Controls />} />
              <Route path="documenti" element={<Documents />} />
              <Route path="report" element={<Reports />} />
            </Route>
            <Route path="/impostazioni" element={<Guard perm="settings.read"><Settings /></Guard>} />
            <Route path="/import" element={<ImportWizard />} />
            <Route path="/audit" element={<Guard perm="audit.read"><AuditLog /></Guard>} />
            <Route path="/notifiche" element={<Notifications />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
